import React, { useEffect, useState } from 'react';
import './App.css';

import { DashBoard } from './pages/dashboard/dashboard';
import { BrowserRouter } from 'react-router-dom';
import { RoutesComponent } from './routes';
import { ResponseHandler } from './components/responseHandler/ResponseHandler';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { getMode } from './commons/utils/ui.utils';
import { useSelector } from 'react-redux';
import { RootState } from './store/rootReducer';

function App() {
  const getTheme = (mode: 'light' | 'dark') => {
    return createTheme({
      palette: {
        type: mode ?? getMode()
      }
    })
  }
  const mode = useSelector<RootState>(x => x.mode.model ?? getMode()) as 'light' | 'dark'
  const [theme, setTheme] = useState(getTheme(mode))

  useEffect(() => {
    if (theme.palette.type !== mode) {
      setTheme(getTheme(mode))
    }
  }, [mode])
  return (
    <ThemeProvider theme={theme}>
      {/* <InstallationPrompt /> */}
      <ResponseHandler />
      <BrowserRouter>
        <DashBoard routes={
          <RoutesComponent />
        } />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
